import { CSSProperties, FC, PropsWithChildren } from 'react'
import { Scrollbars } from 'react-custom-scrollbars-4'

import { useTheme } from '@mui/material'

import './disableNativeScrollbar.css'

type Props = PropsWithChildren<{
  style?: CSSProperties
  testId?: string
}>

export const Scrollbar: FC<Props> = ({ children, style, testId }) => {
  const {
    palette: { scrollbar }
  } = useTheme()

  return (
    <Scrollbars
      autoHide
      data-testid={testId}
      renderView={(props) => <div {...props} style={{ ...props.style }} />}
      renderThumbHorizontal={(props) => (
        <div
          {...props}
          style={{
            ...props.style,
            ...(scrollbar?.thumb?.horizontal || {})
          }}
        />
      )}
      renderThumbVertical={(props) => (
        <div
          {...props}
          style={{
            ...props.style,
            ...(scrollbar?.thumb?.vertical || {})
          }}
        />
      )}
      className="disable-native-scrollbar"
      autoHideDuration={225}
      autoHideTimeout={225}
      autoHeight
      autoHeightMax="100%"
      style={style}
    >
      {children}
    </Scrollbars>
  )
}
